import React, { FC, memo } from 'react'
import PlayIcon from '@ucheba/ui/icons/icon__circled-play.svg'
import SC from '../base/VideoPreviewDefaultPlayIcon.styles'
import { IVideoPreviewDefaultPlayIcon } from '../types'

const { Block } = SC

/** Дефолтная иконка плея */
const VideoPreviewDefaultPlayIcon: FC<IVideoPreviewDefaultPlayIcon> = (props) => {
  const { color = 'white', size = 'medium' } = props

  return (
    <Block size={size}>
      <PlayIcon color={color} />
    </Block>
  )
}

export { VideoPreviewDefaultPlayIcon }
export default memo(VideoPreviewDefaultPlayIcon)
